import m from "../../geodata/es2015/cameroonHigh";
window.am4geodata_cameroonHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/cameroonHigh.js
// module id = null
// module chunks = 